import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';
import { ISource } from 'entities/Source/model/types';
import {
	closeOnboardingModal,
	EOnboardingStates,
	EOnboardingSteps,
	EResultTypes,
	openOnboardingModal,
	setCreatedSource,
	setModalState,
	setResultType,
	setStep,
} from 'features/Onboarding';

export const useOnboardingSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.onboardingSlice),
		setModalState: (state: EOnboardingStates) => dispatch(setModalState(state)),
		setStep: (step: EOnboardingSteps) => dispatch(setStep(step)),
		closeOnboardingModal: () => dispatch(closeOnboardingModal()),
		openOnboardingModal: () => dispatch(openOnboardingModal()),
		setCreatedSource: (source: ISource | null) => dispatch(setCreatedSource(source)),
		setResultType: (type: EResultTypes) => dispatch(setResultType(type)),
	};
};
